import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './styles.module.scss';

interface AdminToolbarProps {
  className?: string;
}

const AdminToolbar: React.FC<AdminToolbarProps> = ({ className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const adminPages = [
    {
      path: '/admin/matches',
      label: 'Match Updates',
      icon: '⚽',
      description: 'Update match scores from API-Football'
    },
    {
      path: '/admin/debug-api',
      label: 'Debug API',
      icon: '🐛',
      description: 'Debug API-Football responses'
    }
  ];

  const isCurrentPage = (path: string) => location.pathname === path;

  return (
    <div className={`${styles.card} ${className}`}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <span className={styles.headerIcon}>🛠️</span>
          <h2 className={styles.title}>Admin Tools</h2>
        </div>
        <div className={styles.headerRight}>
          Administration Panel
        </div>
      </div>

      <div className={styles.grid}>
        {adminPages.map((page) => (
          <button
            key={page.path}
            onClick={() => navigate(page.path)}
            className={`${styles.pageBtn} ${isCurrentPage(page.path) ? styles.pageBtnActive : ''}`}
          >
            <span className={styles.pageIcon}>{page.icon}</span>
            <div className={styles.pageContent}>
              <div className={styles.pageLabel}>{page.label}</div>
              <div className={styles.pageDescription}>{page.description}</div>
            </div>
            {isCurrentPage(page.path) && (
              <span className={styles.currentMarker}>📍</span>
            )}
          </button>
        ))}
      </div>

      <div className={styles.footer}>
        <div className={styles.footerText}>
          Admin tools for PClash tournament management
        </div>
      </div>
    </div>
  );
};

export default AdminToolbar;
